import React, { useState, useEffect, useContext } from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import Card from "react-bootstrap/Card";
import DailyInvoiceSum from "./DailyInvoiceSum";
import DailyInvoiceNumber from "./DailyInvoiceNumber";
import UnfiscalInvoicesTotal from "./UnfiscalInvoicesTotal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import "../../../node_modules/react-grid-layout/css/styles.css";
import "../../../node_modules/react-resizable/css/styles.css";

const DashboardLayoutStatistics = (props) => {
  const { updatePerformances } = useContext(GlobalContext);
  const ResponsiveGridLayout = WidthProvider(Responsive);

  const onLayoutChange = (layout, layouts) => {
    saveToLocalStorage("layouts", layouts);
  };

  

  const saveToLocalStorage = (key, value) => {
    if (global.localStorage) {
      global.localStorage.setItem(
        "cardsOrderStatistics",
        JSON.stringify({
          [key]: value,
        })
      );
    }
  };

  for (let t = 0; t <= 300; t += 10) {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, t);
  }

  const loadFromLocalStorage = (key) => {
    let localStorage = {};
    if (global.localStorage) {
      try {
        localStorage =
          JSON.parse(global.localStorage.getItem("cardsOrderStatistics")) || {};
      } catch (e) {
        // ignore for now
      }
    }
    return localStorage["layouts"];
  };

  const originalLayouts = JSON.parse(
    JSON.stringify(loadFromLocalStorage("cardsOrderStatistics") || {})
  );
  const [layouts, setLayouts] = useState(originalLayouts);

  return (
    <>
    <hr/>
    <h2>Statistika</h2>
      {  (
        <ResponsiveGridLayout
          className="layout"
          cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
          rowHeight={120}
          layouts={layouts}
          width={1200}
          isDraggable={false}
          isResizable={false}
          onLayoutChange={(layout, layouts) => onLayoutChange(layout, layouts)}
        >
         
          <Card
            hidden={false}
            key={"dailyInvoiceCount"}
            data-grid={{ x: 0, y: 0, w: 3, h: 2 }}
            className="text-center dashboard dashboard-tenant-data"
          >
            <DailyInvoiceNumber />
          </Card>

          <Card
            hidden={false}
            key={"dailyInvoiceSum"}
            data-grid={{ x: 6, y: 2, w: 3, h: 2 }}
            className="text-center dashboard dashboard-pos-data"
          >
            <DailyInvoiceSum />
          </Card>

          <Card
            hidden={false}
            key={"unfiscalInvoiceTotal"}
            data-grid={{ x: 3, y: 0, w: 3, h: 2 }}
            className="text-center dashboard dashboard-user-data"
          >
            <UnfiscalInvoicesTotal />
          </Card>

          

        

         

        
        </ResponsiveGridLayout>
      )}
    </>
  );
};

export default DashboardLayoutStatistics;
